import { inject, injectable } from "inversify";
import { SERVICES_TYPES } from "@/ioc/SERVICES_TYPES";
import { HttpClient } from "@/services/client";
import { OrganizationPlan, Package, PlanSettings } from "@/models/package";
import { IPackagesApi } from "./IPackagesApi";

@injectable()
export class PackagesApi implements IPackagesApi {
  @inject(SERVICES_TYPES.HTTP_CLIENT)
  private client: HttpClient;

  async getPackages(): Promise<Package[]> {
    const { data } = await this.client.get<Package[]>("/admin/packages");
    return data;
  }

  async updatePackage(key: string, settings: PlanSettings): Promise<Package> {
    const { data } = await this.client.patch<Package>(`/admin/packages/${key}`, settings);
    return data;
  }

  async getOrganizationPlan(organizationId: string): Promise<OrganizationPlan> {
    const { data } = await this.client.get<OrganizationPlan>(
      `/admin/organizations/${organizationId}/plan`
    );
    return data;
  }

  async updateOrganizationPlan(
    organizationId: string,
    plan: PlanSettings & { package: string | null }
  ): Promise<OrganizationPlan> {
    const { data } = await this.client.patch<OrganizationPlan>(
      `/admin/organizations/${organizationId}/plan`,
      plan
    );
    return data;
  }
}
